import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoryJira = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	width: "1em",
	height: "1em",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8571 0H5.14286C2.30254 0 0 2.30254 0 5.14286V30.8571C0 33.6975 2.30254 36 5.14286 36H30.8571C33.6975 36 36 33.6975 36 30.8571V5.14286C36 2.30254 33.6975 0 30.8571 0Z",
			fill: "#63BA3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.1425 7.71435H12.8568C11.4374 7.71435 10.2854 8.86635 10.2854 10.2858V27.0001C10.2854 27.7098 10.8614 28.2858 11.5711 28.2858C12.0211 28.2858 12.3965 28.0415 12.6254 27.6918L12.6357 27.6943L17.5883 21.9601C17.794 21.6875 18.2054 21.6875 18.4111 21.9601L23.3637 27.6943L23.374 27.6918C23.6028 28.0415 23.9783 28.2858 24.4283 28.2858C25.138 28.2858 25.714 27.7098 25.714 27.0001V10.2858C25.714 8.86635 24.562 7.71435 23.1425 7.71435Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgStoryJira);
export { ForwardRef as ReactComponent };
